import { render, staticRenderFns } from "./frequent_route_config.vue?vue&type=template&id=443fb24b&scoped=true"
import script from "./frequent_route_config.vue?vue&type=script&lang=js"
export * from "./frequent_route_config.vue?vue&type=script&lang=js"
import style0 from "./frequent_route_config.vue?vue&type=style&index=0&id=443fb24b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443fb24b",
  null
  
)

export default component.exports